/* Environment background elements — rendered behind the kiwi variant. */

import type { KiwiPalette } from "../kiwiPalettes";
import type { Environment } from "@/types/kiwiSkin";

export function renderEnvironment(palette: KiwiPalette, env: Environment) {
  switch (env) {
    case "starfield":
      return (
        <>
          <rect x="2" y="2" width="1" height="1" fill={palette.accent} opacity={0.4} />
          <rect x="28" y="4" width="1" height="1" fill={palette.accent} opacity={0.5} />
          <rect x="6" y="8" width="1" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="26" y="14" width="1" height="1" fill={palette.accent} opacity={0.35} />
          <rect x="0" y="18" width="1" height="1" fill={palette.accent} opacity={0.25} />
          <rect x="30" y="22" width="1" height="1" fill={palette.accent} opacity={0.4} />
          <rect x="4" y="26" width="1" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="28" y="28" width="1" height="1" fill={palette.accent} opacity={0.2} />
        </>
      );
    case "underwater":
      return (
        <>
          {/* Bubbles */}
          <rect x="28" y="6" width="2" height="2" fill={palette.accent} opacity={0.2} rx="1" />
          <rect x="26" y="10" width="1" height="1" fill={palette.accent} opacity={0.15} />
          <rect x="30" y="14" width="2" height="2" fill={palette.accent} opacity={0.25} rx="1" />
          <rect x="0" y="8" width="2" height="2" fill={palette.accent} opacity={0.15} rx="1" />
          <rect x="2" y="20" width="1" height="1" fill={palette.accent} opacity={0.2} />
          <rect x="28" y="24" width="2" height="2" fill={palette.accent} opacity={0.15} rx="1" />
        </>
      );
    case "volcanic":
      return (
        <>
          {/* Lava glow below */}
          <rect x="0" y="28" width="32" height="4" fill={palette.accent} opacity={0.15} />
          <rect x="2" y="26" width="28" height="2" fill={palette.accent} opacity={0.08} />
          {/* Ember particles rising */}
          <rect x="28" y="20" width="1" height="1" fill={palette.accent} opacity={0.4} />
          <rect x="2" y="16" width="1" height="1" fill={palette.accent} opacity={0.3} />
          <rect x="30" y="12" width="1" height="1" fill={palette.accent} opacity={0.25} />
          <rect x="0" y="6" width="1" height="1" fill={palette.accent} opacity={0.2} />
        </>
      );
    case "aurora":
      return (
        <>
          {/* Horizontal light bands at top */}
          <rect x="0" y="0" width="32" height="2" fill={palette.accent} opacity={0.12} />
          <rect x="4" y="2" width="24" height="1" fill={palette.highlight} opacity={0.1} />
          <rect x="2" y="3" width="28" height="1" fill={palette.accent} opacity={0.08} />
          <rect x="8" y="4" width="16" height="1" fill={palette.highlight} opacity={0.06} />
        </>
      );
    case "snowscape":
      return (
        <>
          {/* Falling snowflakes */}
          <rect x="28" y="2" width="2" height="2" fill={palette.accent} opacity={0.2} />
          <rect x="4" y="4" width="1" height="1" fill={palette.accent} opacity={0.15} />
          <rect x="24" y="8" width="2" height="2" fill={palette.accent} opacity={0.18} />
          <rect x="30" y="12" width="2" height="2" fill={palette.accent} opacity={0.2} />
          <rect x="2" y="16" width="1" height="1" fill={palette.accent} opacity={0.12} />
          <rect x="28" y="20" width="2" height="2" fill={palette.accent} opacity={0.15} />
          {/* Snow ground */}
          <rect x="0" y="30" width="32" height="2" fill={palette.accent} opacity={0.1} />
        </>
      );
    case "matrix":
      return (
        <>
          {/* Falling code rain columns */}
          <rect x="2" y="0" width="1" height="2" fill={palette.accent} opacity={0.3} />
          <rect x="2" y="4" width="1" height="1" fill={palette.accent} opacity={0.2} />
          <rect x="2" y="6" width="1" height="2" fill={palette.accent} opacity={0.15} />
          <rect x="28" y="2" width="1" height="2" fill={palette.accent} opacity={0.25} />
          <rect x="28" y="6" width="1" height="1" fill={palette.accent} opacity={0.2} />
          <rect x="28" y="8" width="1" height="2" fill={palette.accent} opacity={0.35} />
          <rect x="30" y="0" width="1" height="1" fill={palette.accent} opacity={0.2} />
          <rect x="30" y="4" width="1" height="2" fill={palette.accent} opacity={0.15} />
          <rect x="0" y="10" width="1" height="2" fill={palette.accent} opacity={0.2} />
          <rect x="0" y="14" width="1" height="1" fill={palette.accent} opacity={0.25} />
        </>
      );
    default:
      return null;
  }
}
